"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _vue = _interopRequireDefault(require("vue"));
var _elementUi = require("element-ui");
// Vue.use(Pagination);
// Vue.use(Dialog);
// Vue.use(Autocomplete);
_vue.default.use(_elementUi.Dropdown);
_vue.default.use(_elementUi.DropdownMenu);
_vue.default.use(_elementUi.DropdownItem);
// Vue.use(Menu);
// Vue.use(Submenu);
// Vue.use(MenuItem);
// Vue.use(MenuItemGroup);
_vue.default.use(_elementUi.Input);
_vue.default.use(_elementUi.InputNumber);
_vue.default.use(_elementUi.Radio);
_vue.default.use(_elementUi.RadioGroup);
_vue.default.use(_elementUi.RadioButton);
_vue.default.use(_elementUi.Checkbox);
_vue.default.use(_elementUi.CheckboxButton);
_vue.default.use(_elementUi.CheckboxGroup);
_vue.default.use(_elementUi.Switch);
_vue.default.use(_elementUi.Select);
_vue.default.use(_elementUi.Option);
_vue.default.use(_elementUi.OptionGroup);
_vue.default.use(_elementUi.Button);
_vue.default.use(_elementUi.ButtonGroup);
// Vue.use(Table);
// Vue.use(TableColumn);
// Vue.use(DatePicker);
// Vue.use(TimeSelect);
// Vue.use(TimePicker);
// Vue.use(Popover);
_vue.default.use(_elementUi.Tooltip);
// Vue.use(Breadcrumb);
// Vue.use(BreadcrumbItem);
_vue.default.use(_elementUi.Form);
_vue.default.use(_elementUi.FormItem);
// Vue.use(Tabs);
// Vue.use(TabPane);
// Vue.use(Tag);
// Vue.use(Tree);
// Vue.use(Alert);
// Vue.use(Slider);
// Vue.use(Icon);
// Vue.use(Row);
// Vue.use(Col);
_vue.default.use(_elementUi.Upload);
// Vue.use(Progress);
// Vue.use(Badge);
// Vue.use(Card);
// Vue.use(Rate);
// Vue.use(Steps);
// Vue.use(Step);
_vue.default.use(_elementUi.Carousel);
_vue.default.use(_elementUi.CarouselItem);
_vue.default.use(_elementUi.Collapse);
_vue.default.use(_elementUi.CollapseItem);
// Vue.use(Cascader);
_vue.default.use(_elementUi.ColorPicker);
// Vue.use(Transfer);
_vue.default.use(_elementUi.Container);
_vue.default.use(_elementUi.Header);
_vue.default.use(_elementUi.Aside);
_vue.default.use(_elementUi.Main);
_vue.default.use(_elementUi.Footer);
_vue.default.use(_elementUi.Loading.directive);
_vue.default.prototype.$loading = _elementUi.Loading.service;
_vue.default.prototype.$msgbox = _elementUi.MessageBox;
_vue.default.prototype.$alert = _elementUi.MessageBox.alert;
_vue.default.prototype.$confirm = _elementUi.MessageBox.confirm;
_vue.default.prototype.$prompt = _elementUi.MessageBox.prompt;
// Vue.prototype.$notify = Notification;
_vue.default.prototype.$message = _elementUi.Message;